import React, { useRef } from 'react';

import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import Modal from 'react-bootstrap/Modal';
import JobEditor from '../job/JobEditor';
import ServiceCallEditor from '../service-call/ServiceCallEditor';
import ActionButton from '../shared/buttons/ActionButton';

const JobCalendar = ({
    appointment,
    cHandler
}) => {
    const calendarRef = useRef(null);

    const changeCalendarView = (data) => {
        const calendarApi = calendarRef.current.getApi();
        if (calendarApi.view.type === 'customWeek' || calendarApi.view.type === 'customMonth') {
            calendarApi.changeView('schedulerDay', data.date);
        }
    }

    return (
        <div>
            <FullCalendar
                ref={calendarRef}
                schedulerLicenseKey={'0820983039-fcs-1734877181'}
                plugins={[interactionPlugin, resourceTimelinePlugin, dayGridPlugin, timeGridPlugin]}
                selectable={cHandler.selectedEvent}
                initialView="customMonth"
                dateClick={changeCalendarView}
                events={cHandler.events}
                datesSet={(dateInfo) => cHandler.setDates(dateInfo)}
                height={'calc(100vh - 220px)'}
                resources={cHandler.resources}
                resourceAreaWidth={'150px'}
                eventClick={cHandler.eventClick}
                displayEventTime={false}
                select={cHandler.select}
                titleFormat={{ year: 'numeric', month: 'short', day: 'numeric' }}
                navLinks={true}
                themeSystem={'bootstrap'}
                eventDisplay={'block'}
                eventContent={cHandler.formatEvent}
                headerToolbar={
                    {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'schedulerDay,customDay,customWeek,customMonth'
                    }}
                buttonText={cHandler.buttonText}
                views={cHandler.views}
            />
            {cHandler.selectedEvent &&
                !appointment &&
                <Modal size="lg" show={true} onHide={cHandler.resetView}>
                    <Modal.Header className="py-1" closeButton>
                        <span className="section-title">
                            <ActionButton
                                imgSource="/images/customer_dark.svg"
                                buttonText={cHandler.selectedEvent.title}
                                onClick={() => window.location = `/customers/edit/${cHandler.selectedEvent.customerId}`}
                            />
                        </span>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        {cHandler.selectedEvent.appointmentType === 2 ? (
                            <JobEditor
                                editId={parseInt(cHandler.selectedEvent.jobId)}
                                customerId={0}
                                proposalId={0}
                                cancelEdit={cHandler.resetView}
                                scheduleOverride={cHandler.startScheduling}
                                fetchData={cHandler.resetView} />
                        ) : (
                            <ServiceCallEditor
                                editId={parseInt(cHandler.selectedEvent.serviceCallId)}
                                customerId={0}
                                cancelEdit={cHandler.resetView}
                                scheduleOverride={cHandler.startScheduling}
                                fetchData={cHandler.resetView} />
                        )}
                    </Modal.Body>
                </Modal>
            }
        </div>
    );
}

export default JobCalendar;
